import { render, staticRenderFns } from "./ColorCircle.vue?vue&type=template&id=342362ab&scoped=true"
import script from "./ColorCircle.vue?vue&type=script&lang=js"
export * from "./ColorCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342362ab",
  null
  
)

export default component.exports